// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"dashboard-module__dashboard___3UOer","content":"dashboard-module__content___i0PDu"};